module.exports = __webpack_public_path__ + "static/media/take-notes.87d21dd0.svg";